import { render, staticRenderFns } from "./ChatTypeTabs.vue?vue&type=template&id=6594954a&scoped=true&"
import script from "./ChatTypeTabs.vue?vue&type=script&lang=js&"
export * from "./ChatTypeTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChatTypeTabs.vue?vue&type=style&index=0&id=6594954a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6594954a",
  null
  
)

export default component.exports